export enum PersonalSettingsSection {
	Profile,
	EmailAndCalendar,
	Security,
	SocialMedia,
	EmailSignature,
	ImportContacts,
	Texting,
	Notifications,
}
